import React from 'react';
import { connect } from 'react-redux';

import mea from '../../../services/mea';
import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, HEADER_MOBILE_MEDIA_QUERY } from '../../../constants';
import { RECHERCHE_VERSION_MENU_MOBILE_SLIDE } from '../../../services/header/constants';

import { toggleMenuMobileSlide } from '../../../services/header/actions';

import { getHomeFeaturedCategories } from '../../../services/category/selector';
import { getQueryParams } from '../../../utils/routeUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import MeaCarouselComponent from './MeaCarouselComponent';
import MobileMeaOfferSelection from './MobileMeaOfferSelection';
import DesktopMeaOfferSelection from './DesktopMeaOfferSelection';
import HowItWorksComponent from '../../HowItWorksComponent';

import './HomePage.scss';

export class HomePage extends React.Component {
    componentDidMount() {
        this.props.fetchMeasIfNeeded(mea.constants.CAROUSEL_MEA_TYPE);
        this.props.fetchMeasIfNeeded(mea.constants.SELECTION_MOMENT_MEA_TYPE);
        this.props.fetchMeasIfNeeded(mea.constants.CATEGORY_OFFER_MEA_TYPE);
        this.focusSearchIfRequested();
    }

    componentWillUnmount() {
        clearTimeout(this.searchFocusTimeout);
    }

    // ?search=1 : place le curseur dans le champ de recherche à l'arrivée sur
    // la home (deep link MBI). En header mobile, le champ est dans la slide
    // de recherche : on l'ouvre d'abord. Le focus est différé pour passer
    // après celui du RouteAnnouncer (100ms) et celui de l'ouverture de slide.
    focusSearchIfRequested = () => {
        if (getQueryParams(this.props.location.search).search !== '1') {
            return;
        }

        if (window.matchMedia(HEADER_MOBILE_MEDIA_QUERY).matches) {
            this.props.toggleMenuMobileSlide(RECHERCHE_VERSION_MENU_MOBILE_SLIDE);
        }

        this.searchFocusTimeout = setTimeout(() => {
            const input = document.getElementById('champrecherche');
            if (input) {
                input.focus();
            }
        }, 200);
    };

    render() {
        const { i18nHome, featuredCategories } = this.props;

        return (
            <main role="main" className="conteneur" id="p-accueil">
                <HeadComponent
                    title={i18nHome.TITLE}
                    description={i18nHome.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.HOME_PATH}`}
                />

                <MeaCarouselComponent />

                <HowItWorksComponent showTitle showButtons cssClass="conteneur conteneur-mobile" />

                <DesktopMeaOfferSelection isMoment />
                <MobileMeaOfferSelection isMoment />

                {featuredCategories.map(category => (
                    <React.Fragment key={category.id}>
                        <DesktopMeaOfferSelection category={category} />
                        <MobileMeaOfferSelection category={category} />
                    </React.Fragment>
                ))}
            </main>
        );
    }
}

const mapStateToProps = state => ({
    i18nHome: state.i18n.page.HOME,
    featuredCategories: getHomeFeaturedCategories(state)
});

const mapDispatchToProps = {
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded,
    toggleMenuMobileSlide
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HomePage),
    PrimaryTemplate,
    {
        hideBreadcrumb: true
    }
);



// WEBPACK FOOTER //
// ./src/components/pages/home/HomePage.js